import {get as _get, isEmpty as _isEmpty} from 'lodash';
import moment from 'moment';

import {showErrorModal} from '@utils/modal';
import {dateEmpty} from '@utils/date';
import {HAS_NO_COVERAGE, HAS_PARTIAL_COVERAGE} from '@constants/variables';

export const CONSTRAINT_ERROR_HEADER = 'Error with filters';
export const EMPTY_DATE_RANGE_MESSAGE = 'You must enter a start time and an end time.';

export const getDateRangeDays = (from, to) => {
    const fromDate = moment(from, 'YYYY-MM-DD');
    const toDate = moment(to, 'YYYY-MM-DD');

    return moment.duration(toDate.diff(fromDate)).asDays();
};

export const reportQualifiesAsExtraFilter = (
    report,
    qualifyingValues = [HAS_NO_COVERAGE, HAS_PARTIAL_COVERAGE]
) => {
    if (!Array.isArray(report) || _isEmpty(report)) {
        return false;
    }

    return report.every((value) => qualifyingValues.includes(value));
};

export const hasQualifyingExtraFilter = (filters, {
    emptyFilterKeys = [],
    reportKey = null,
    reportQualifyingValues = [HAS_NO_COVERAGE, HAS_PARTIAL_COVERAGE],
    qualifyingChecks = [],
} = {}) => {
    for (const key of emptyFilterKeys) {
        if (!_isEmpty(_get(filters, key, []))) {
            return true;
        }
    }

    if (reportKey && reportQualifiesAsExtraFilter(_get(filters, reportKey, []), reportQualifyingValues)) {
        return true;
    }

    for (const check of qualifyingChecks) {
        if (check(filters)) {
            return true;
        }
    }

    return false;
};

export const createNoRequiredFilters = ({
    allowedDays,
    emptyFilterKeys = [],
    reportKey = null,
    reportQualifyingValues = [HAS_NO_COVERAGE, HAS_PARTIAL_COVERAGE],
    qualifyingChecks = [],
}) => (from, to, filters) => {
    if (getDateRangeDays(from, to) <= allowedDays) {
        return false;
    }

    return !hasQualifyingExtraFilter(filters, {
        emptyFilterKeys,
        reportKey,
        reportQualifyingValues,
        qualifyingChecks,
    });
};

export const createSkipSearch = (noRequiredFiltersFn) => (props) => {
    const from = _get(props, 'filters.from', null);
    const to = _get(props, 'filters.to', null);

    return dateEmpty(from, to) || noRequiredFiltersFn(from, to, props.filters);
};

export const createShowConstraintsModal = (noRequiredFiltersFn, sevenDayModalMessage) => (data) => {
    if (dateEmpty(data.from, data.to)) {
        showErrorModal({
            header: CONSTRAINT_ERROR_HEADER,
            text: EMPTY_DATE_RANGE_MESSAGE,
        });
    }

    if (noRequiredFiltersFn(data.from, data.to, data)) {
        showErrorModal({
            header: CONSTRAINT_ERROR_HEADER,
            text: sevenDayModalMessage,
        });
    }
};
